module.exports = __webpack_public_path__ + "media/ToDust-nihil-est.1c187239.mp3";